var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microsoft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.74 9.21h6.2c.585 0 1.06.474 1.06 1.06v5.646a3.898 3.898 0 0 1-3.898 3.898h-.018a3.898 3.898 0 0 1-3.898-3.897V9.764c0-.307.248-.555.554-.555ZM20.93 8.093a2.512 2.512 0 1 0 0-5.023 2.512 2.512 0 0 0 0 5.023Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.116 8.093a3.628 3.628 0 1 0 0-7.256 3.628 3.628 0 0 0 0 7.256ZM17.954 9.21H7.72a1.05 1.05 0 0 0-1.023 1.073v6.44a6.295 6.295 0 0 0 6.14 6.44 6.295 6.295 0 0 0 6.139-6.44v-6.44a1.05 1.05 0 0 0-1.023-1.074Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.395 9.21v9.024a1.028 1.028 0 0 1-1.021 1.022H7.189a6.797 6.797 0 0 1-.491-2.534V10.28a1.048 1.048 0 0 1 1.021-1.072h5.676Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.837 9.21v9.583a1.028 1.028 0 0 1-1.021 1.021H7.45a7.236 7.236 0 0 1-.262-.558 6.797 6.797 0 0 1-.491-2.534V10.28a1.048 1.048 0 0 1 1.021-1.072h5.118Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.837 9.21v8.466a1.03 1.03 0 0 1-1.021 1.022H6.993a6.797 6.797 0 0 1-.295-1.976V10.28a1.048 1.048 0 0 1 1.021-1.072h5.118Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.28 9.21v8.466a1.03 1.03 0 0 1-1.022 1.022H6.993a6.797 6.797 0 0 1-.295-1.976V10.28a1.048 1.048 0 0 1 1.021-1.072h4.56Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.395 6.324v1.758c-.095.005-.184.011-.279.011-.095 0-.184-.006-.279-.011a3.062 3.062 0 0 1-.558-.09A3.628 3.628 0 0 1 9.767 5.86a3.1 3.1 0 0 1-.178-.558h2.785c.563.002 1.02.459 1.021 1.022Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.837 6.882v1.2a3.062 3.062 0 0 1-.558-.09A3.628 3.628 0 0 1 9.767 5.86h2.049c.563.003 1.02.459 1.021 1.022Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.837 6.882v1.2a3.062 3.062 0 0 1-.558-.09A3.628 3.628 0 0 1 9.767 5.86h2.049c.563.003 1.02.459 1.021 1.022Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.28 6.882v1.11A3.628 3.628 0 0 1 9.766 5.86h1.49c.564.003 1.02.459 1.022 1.022Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.023 5.86h10.233c.565 0 1.023.459 1.023 1.024v10.232c0 .566-.458 1.024-1.023 1.024H1.023A1.023 1.023 0 0 1 0 17.116V6.884C0 6.319.458 5.86 1.023 5.86Z",
    fill: "url(#microsoft_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.832 9.755H6.786v5.57H5.483v-5.57H3.447v-1.08h5.385v1.08Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft_svg__b",
    x1: 2.133,
    y1: 5.061,
    x2: 10.146,
    y2: 18.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "microsoft_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .837)",
    d: "M0 0h24v22.326H0z"
  })))));
};
export default SvgMicrosoft;